import { useEffect, useState } from 'react'

/** Layout regions that can be highlighted as an "open in" destination. */
export type PanelDestinationPreview = 'main' | 'agent'

const PANEL_DESTINATION_PREVIEW_EVENT = 'flownotes-panel-destination-preview'

export function setPanelDestinationPreview(target: PanelDestinationPreview): void {
  window.dispatchEvent(
    new CustomEvent(PANEL_DESTINATION_PREVIEW_EVENT, { detail: { target } }),
  )
}

export function clearPanelDestinationPreview(): void {
  window.dispatchEvent(
    new CustomEvent(PANEL_DESTINATION_PREVIEW_EVENT, { detail: { target: null } }),
  )
}

/** Subscribe to which layout panel should show destination highlight (context menu hover). */
export function usePanelDestinationPreview(): PanelDestinationPreview | null {
  const [target, setTarget] = useState<PanelDestinationPreview | null>(null)

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ target?: PanelDestinationPreview | null }>).detail
      setTarget(detail?.target ?? null)
    }
    window.addEventListener(PANEL_DESTINATION_PREVIEW_EVENT, handler)
    return () => window.removeEventListener(PANEL_DESTINATION_PREVIEW_EVENT, handler)
  }, [])

  return target
}

export function panelDestinationPreviewClass(
  active: PanelDestinationPreview | null,
  region: PanelDestinationPreview,
): string {
  return active === region ? 'panel-destination-preview' : ''
}
